import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { StellantisLayoutComponent } from '../stellantis-layout/stellantis-layout.component';
import {LoginModalComponent} from '../auth/login/stellantis/login-modal.component';

const routes: Routes = [
  { path: '', component: StellantisLayoutComponent }
];

@NgModule({
  declarations: [
    // LoginModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class StellantisModule { }
